import { HedaderProps } from "@/types";

// Componente para mostrar el logo de la aplicación
const Logo: React.FC<HedaderProps> = ({
  src = "/img/logo/LogoLinkServs.png", // 🔹 Ruta de la imagen por defecto
  alt = "Logo",                   // 🔹 Texto alternativo para accesibilidad
  className = "h-14 xs:h-14",     // 🔹 Clases CSS por defecto para tamaño
}) => {
  return (
    <div className="pl-4">
      {/* 🔹 Enlace que lleva a la página principal */}
      <a href="/">
        {/* 🔹 Imagen del logo */}
        <img src={src} alt={alt} className={className} />
      </a>
    </div>
  );
};

export default Logo;
